import { FORMATTER_STYLE, getFormatter } from '../../utils/formatter';

const defaultStyle = {
  alignSelf: 'center',
};

export const COLUMN_STYLE = {
  coefficient: 'coeff',
  float2: 'float2',
  decimal: 'decimal',
  thumbnail: 'thumb',
  category: 'cat',
  action: 'action',
  text: 'text',
};

export const getColumnStyle = type => {
  switch (type) {
    case COLUMN_STYLE.coefficient:
      return {
        style: {
          ...defaultStyle,
          textAlign: 'right',
        },
        Cell: row => {
          if (row.value === undefined) {
            return 'Accessor Error';
          } else if (row.value === null) {
            return '-';
          } else {
            return getFormatter(FORMATTER_STYLE.floatFractionDigit3)(row.value);
          }
        },
      };
    case COLUMN_STYLE.float2:
      return {
        style: {
          ...defaultStyle,
          textAlign: 'right',
        },
        Cell: row => {
          if (row.value === undefined) {
            return 'Accessor Error';
          } else if (row.value === null) {
            return '-';
          } else {
            return getFormatter(FORMATTER_STYLE.floatFractionDigit2)(row.value);
          }
        },
      };
    case COLUMN_STYLE.thumbnail:
      return {
        width: 70,
        style: {
          ...defaultStyle,
          textOverflow: 'unset',
        },
      };
    case COLUMN_STYLE.category:
      return {
        width: 100,
        style: { ...defaultStyle },
      };
    case COLUMN_STYLE.action:
      return {
        width: 120,
        style: { ...defaultStyle },
      };
    case COLUMN_STYLE.text:
      return {
        style: {
          ...defaultStyle,
          whiteSpace: 'normal',
        },
      };
    case COLUMN_STYLE.decimal:
      return {
        style: {
          ...defaultStyle,
          textAlign: 'right',
        },
        Cell: row => {
          if (row.value === undefined) {
            return 'Accessor Error';
          } else if (row.value === null) {
            return '-';
          } else {
            return getFormatter(FORMATTER_STYLE.decimal)(row.value);
          }
        },
      };
    default:
      return {};
  }
};

export const searchData = (terms, category, list, accessor) => {
  if(!list) return list;
  return list.filter((item)=>{
    const { is_public } = accessor(item);
    if(category === undefined || category.value === "all") return true;
    else if(category.value === 'public' && is_public) return true;
    else if(category.value === 'private' && !is_public) return true;
    else return false;
  }).filter((item)=>{
    const { name } = accessor(item);
    if(terms === undefined) return true;
    return name.includes(terms);
  });
}



// WEBPACK FOOTER //
// ./src/components/datatable/util.js